export const COMPANY = {
  name: "Jeet IT Services",
  short: "Jeet IT",
  founder: "Jagjeet Singh",
  established: 2016,
  city: "Global",
  email: "info.jeetit@gmail.com",
  phone: "+91 70092-74458",
  phoneRaw: "+917009274458",
  whatsapp: "https://wa.me/917009274458?text=Hi%20Jeet%20IT%2C%20I%27d%20like%20to%20discuss%20a%20project.",
  address: "Serving clients worldwide",
};

export const SERVICES = [
  {
    slug: "web-development",
    code: "01",
    title: "Web Development",
    short: "Modern, fast & scalable web platforms.",
    description:
      "High-performance React and Next.js web applications engineered for scale, speed and conversion. Headless commerce, dashboards, portals.",
    bullets: ["React • Next.js • Node.js", "Headless CMS & APIs", "Performance budgets", "Edge-rendered SEO"],
  },
  {
    slug: "mobile-apps",
    code: "02",
    title: "Mobile Apps",
    short: "Native iOS & Android, cross-platform too.",
    description:
      "React Native and native mobile apps your customers actually use — pixel-perfect UX, offline-first sync, App Store / Play Store delivery.",
    bullets: ["iOS & Android", "React Native", "Offline-first", "Push & analytics"],
  },
  {
    slug: "hosting-cloud",
    code: "03",
    title: "Hosting & Cloud",
    short: "VPS, managed servers & AWS infra.",
    description:
      "From single-region VPS to multi-AZ AWS deployments — hardened, monitored, backed up. We run your infra so your team ships features.",
    bullets: ["AWS • Docker • Linux", "Zero-downtime deploys", "Daily backups", "24/7 monitoring"],
  },
  {
    slug: "blockchain",
    code: "04",
    title: "Blockchain & Web3",
    short: "Smart contracts, dApps & tokenomics.",
    description:
      "Audited Solidity contracts, DeFi protocols, NFT platforms and Web3 integrations on Ethereum, Base and other EVM chains.",
    bullets: ["Solidity audits", "DApp frontends", "Token launches", "On-chain analytics"],
  },
  {
    slug: "seo",
    code: "05",
    title: "SEO & Growth",
    short: "Rank higher on global search.",
    description:
      "Technical SEO, content programs and conversion-focused experiments to dominate global search rankings and grow your pipeline in any market.",
    bullets: ["Technical SEO audits", "Schema & Core Web Vitals", "Content programs", "Conversion experiments"],
  },
  {
    slug: "it-consulting",
    code: "06",
    title: "IT Consulting",
    short: "Strategic technology roadmaps.",
    description:
      "Architecture reviews, vendor selection, security posture and modernization roadmaps for businesses scaling past spreadsheets.",
    bullets: ["Architecture reviews", "Security posture", "Vendor selection", "Modernization plans"],
  },
  {
    slug: "automation",
    code: "07",
    title: "Business Automation",
    short: "AI + workflow systems that scale.",
    description:
      "Internal tooling, document AI, ETL pipelines and workflow automation that eliminate repetitive work and unlock new operating leverage.",
    bullets: ["Workflow automation", "Document AI", "ETL & data pipelines", "Custom integrations"],
  },
  {
    slug: "brand-design",
    code: "08",
    title: "Brand & Templates",
    short: "Identity, visuals & campaign assets.",
    description:
      "Brand identity, marketing site design, ad creative and email templates that match the technical quality of the products we ship.",
    bullets: ["Brand identity", "Landing pages", "Ad creatives", "Email templates"],
  },
];

export const STACK = [
  "React", "Next.js", "Node.js", "TypeScript", "Python", "PHP", "Laravel", "WordPress",
  "PostgreSQL", "MySQL", "MongoDB", "Docker", "Linux", "AWS", "Tailwind CSS", "Solidity", "Ethereum",
];

export const STATS = [
  { value: "10+", label: "Years Active" },
  { value: "240+", label: "Projects Shipped" },
  { value: "98%", label: "Client Retention" },
  { value: "4.98", label: "Average Rating" },
];

export const INDUSTRIES = [
  "Construction", "Healthcare", "Real Estate", "Retail & E-commerce",
  "Education", "Finance", "Professional Services", "Logistics", "Startups", "Data & Analytics",
];

export const PROCESS = [
  { code: "01", title: "Discovery",      text: "Free consult — we map your business goals, constraints and target outcome." },
  { code: "02", title: "Planning",       text: "Scope, transparent timeline and fixed pricing. No surprises." },
  { code: "03", title: "Architecture",   text: "Data models, security model and tech stack chosen before the first line of code." },
  { code: "04", title: "UI / UX",        text: "Wireframes and high-fidelity prototypes reviewed and signed off by you." },
  { code: "05", title: "Build",          text: "Agile sprints, clean code, demos every Friday, full source ownership." },
  { code: "06", title: "QA & Security",  text: "Cross-device QA, performance audits, security checks, accessibility." },
  { code: "07", title: "Deploy",         text: "Zero-downtime launch on optimized infrastructure with rollback ready." },
  { code: "08", title: "Support",        text: "SLA-backed monitoring, maintenance and continuous improvement." },
];

export const PROJECTS = [
  {
    slug: "northbuild",
    category: "Web Development",
    title: "NorthBuild Construction Platform",
    blurb: "Project management portal for a construction firm — scheduling, quoting and client dashboards.",
    metric: "+62% faster quoting",
    stack: ["Next.js", "PostgreSQL", "AWS"],
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80",
  },
  {
    slug: "globalcart",
    category: "E-commerce",
    title: "GlobalCart Retail Suite",
    blurb: "Headless storefront for an international retail chain with multi-warehouse inventory sync.",
    metric: "3.1× online revenue",
    stack: ["Next.js", "Node", "Shopify"],
    image: "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?w=1200&q=80",
  },
  {
    slug: "caresync",
    category: "Mobile App",
    title: "CareSync Patient App",
    blurb: "HIPAA-aligned appointment & telehealth app for a multi-clinic healthcare network.",
    metric: "40k+ downloads / yr",
    stack: ["React Native", "Node", "AWS"],
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80",
  },
  {
    slug: "apex-finance",
    category: "FinTech",
    title: "Apex Finance Trading App",
    blurb: "Institutional mobile trading app with real-time order book and risk dashboards.",
    metric: "185k active users",
    stack: ["React Native", "Python", "Redis"],
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&q=80",
  },
  {
    slug: "chainregistry",
    category: "Blockchain",
    title: "ChainRegistry Platform",
    blurb: "Enterprise NFT + Smart Contract platform for asset registry and provenance.",
    metric: "$18M TVL",
    stack: ["Solidity", "Next.js", "TheGraph"],
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=1200&q=80",
  },
  {
    slug: "rideos",
    category: "Logistics",
    title: "RideOS Dispatch System",
    blurb: "Realtime dispatch and routing system for a regional logistics operator.",
    metric: "27% lower fuel cost",
    stack: ["Node", "Postgres", "Mapbox"],
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1200&q=80",
  },
];

export const FAQS = [
  {
    q: "How long does a typical project take?",
    a: "Marketing sites and corporate websites usually take 4–6 weeks. Custom web apps and dashboards run 10–16 weeks. Mobile apps are typically 14–22 weeks. We share a fixed timeline after the discovery call.",
  },
  {
    q: "Do you work with clients outside your country?",
    a: "Yes — we work with clients across North America, Europe, the Middle East, Asia and Australia. We are fully remote-first and align with your time zone for sync calls.",
  },
  {
    q: "How much does a project cost?",
    a: "Every project is scoped individually. Business sites typically start at $2,500 USD, custom web apps from $8,000 USD, mobile apps from $12,000 USD. You'll get a transparent, fixed quote after discovery.",
  },
  {
    q: "Do you provide ongoing support after launch?",
    a: "Yes. We offer SLA-backed maintenance, monitoring, security patching and continuous improvement packages so your product keeps performing long after launch.",
  },
  {
    q: "Can you take over an existing project or codebase?",
    a: "Absolutely. We've rescued and modernized many existing codebases. We start with a free architecture audit and present a stabilization + roadmap plan.",
  },
  {
    q: "Is blockchain development practical for my business?",
    a: "It depends on the use case. We help you cut through the hype — if Web3 is the right tool we'll build it; if not, we'll tell you so and propose a better solution.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Jeet IT rebuilt our entire ordering platform and our team finally stopped firefighting. Conversion is up, costs are down, and they actually answer the phone.",
    name: "Priya R.",
    role: "Director of Operations, Retail Group",
  },
  {
    quote: "The most senior engineering team we've worked with — anywhere. They told us what NOT to build, and that alone saved us months.",
    name: "David M.",
    role: "Founder, Apex Finance",
  },
  {
    quote: "From day one they treated our project like a 10-year partnership. Smart contracts audited, frontend shipped, KPIs hit.",
    name: "Sara K.",
    role: "Product Lead, ChainRegistry",
  },
];

